import React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const CustomDateField = ({
  label,
  name,
  value,
  onChange,
  required = false,
  error = false,
  helperText = "",
  format = "DD/MM/YYYY",
  disabledAfter = null,
  fullWidth = true,
  size = "small",
  placeholder = "",
  disabled = false,
  ...props
}) => {
  const handleChange = (newValue) => {
    const formattedValue = newValue && dayjs(newValue).isValid() 
      ? newValue.format("YYYY-MM-DD") 
      : "";
    if (onChange) {
      onChange({
        target: {
          name: name,
          value: formattedValue,
        },
      });
    }
  };

  const getValue = () => {
    if (!value) return null;
    return dayjs(value, "YYYY-MM-DD");
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        name={name}
        value={getValue()}
        onChange={handleChange}
        format={format}
        disabled={disabled}
        slotProps={{
          field: { clearable: true },
          actionBar: {
            actions: ['clear', 'today', 'cancel', 'accept'],
          },
          textField: {
            required,
            error,
            helperText,
            fullWidth,
            size,
            placeholder,
            sx: {
              minWidth: 160,
              borderRadius: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                backgroundColor: "#FAFBFC",
                "&:hover fieldset": {
                  borderColor: "#2469F0",
                },
                "& fieldset": {
                  borderColor: "#D0D5DD",
                },
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.75rem",
                fontWeight: 500,
                color: "#475467",
                "&.Mui-focused": {
                  color: "#2469F0",
                },
              },
            },
            InputLabelProps: { shrink: true },
            inputProps: {
              max: disabledAfter || undefined,
            },
            ...props,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDateField;